import React, { useEffect, useState, useRef } from "react"
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate, useLocation } from "react-router-dom"

//import { cookieUpdate, cookieGet } from '../../cookies'
import { useCookies } from 'react-cookie'
import ErrorBoundary from '../../ErrorBoundary'
import { callApi } from '../../api/client'

import Notify from 'devextreme/ui/notify'
import { Button, LoadIndicator } from 'devextreme-react'
import TreeView from 'devextreme-react/tree-view'

import { Box, Typography, CircularProgress, Backdrop } from "@mui/material"
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

import { useIsAuthenticated } from "@azure/msal-react"

import { currentCompany, setCompany } from '../company/companySlice'
import { currentUser, currentPerm, userSrchTerm, setUser } from '../user/userSlice'

import gpsiLogo from '../../assets/gpsiLogo.svg'

import '../../theme/fontawesome.css'
import '../../theme/duotone.css'

const SideBar = (props) => {
    const theme = useTheme()
    const navigate = useNavigate()
    const location = useLocation()
    const dispatch = useDispatch()
    const smallScreen = useMediaQuery(theme.breakpoints.down('md'))
    const menuRef = useRef(null)
    const pageRef = useRef(null)

    const isAuthenticated = useIsAuthenticated()
    const [ cookies, setCookie ] = useCookies(['session_var'])

    const [menuLoading, setMenuLoading] = useState(true)
    const [logoFile, setLogoFile] = useState(gpsiLogo)
    const [menuHeight, setMenuHeight] = useState(0)
    const [mainMenu, setMainMenu] = useState([])

    const currentcompany = useSelector(currentCompany)
    const currentuser = useSelector(currentUser)
    const currentperm = useSelector(currentPerm)
    const srchTerm = useSelector(userSrchTerm)

    useEffect(() => {
        if (pageRef.current) {
            const h = window.innerHeight - pageRef.current.offsetTop
            if (h !== menuHeight) {
                setMenuHeight(h)
            }
        }
        if (menuRef.current && !menuLoading && mainMenu.length === 0) {
            getMainMenu()
        }
    });
    useEffect(() => {
        if (currentuser.id !== 0 && currentcompany.id !== 0 && isAuthenticated) {
            import(`../../assets/${theme.logo}`)
                .then(l => { setLogoFile(l.default) })
            getMainMenu()
        }
    }, [currentuser, currentcompany, isAuthenticated]);

    useEffect(() => {
        if (menuRef.current) {
            callApi('Menu/GetMenuSearch', {
                companyid: currentcompany.id,
                userid: currentuser.id,
                parentid: null,
                searchValue: srchTerm,
            })
                .then(res => {
                    //console.log(res)
                    const a1 = mainMenu.filter(f => f.parentId !== '2_2')
                    const a2 = a1.filter(f => f.parentId !== '2_3')
                    const a3 = a2.filter(f => f.parentId !== '2_4')
                    setMainMenu(a3.concat(res))
                    const inst = menuRef.current.instance()
                    if (res.find(f => f.id === '2_2_0')) {
                        inst.collapseItem('2_2')
                    } else {
                        inst.expandItem('2_2')
                    }
                    if (res.find(f => f.id === '2_3_0')) {
                        inst.collapseItem('2_3')
                    } else {
                        inst.expandItem('2_3')
                    }
                    if (res.find(f => f.id === '2_4_0')) {
                        inst.collapseItem('2_4')
                    } else {
                        inst.expandItem('2_4')
                    }
                }).catch(err => {
                    Notify({
                        message: err,
                        minHeight: 45,
                        minWidth: 150,
                        type: 'error',
                    }, {
                        position: 'bottom center',
                        direction: 'up-push'
                    })
                })
        }
    }, [srchTerm]);

    //if (logoFile !== theme.logo) {
    //    import(`../../assets/${theme.logo}`)
    //        .then(l => { setLogoFile(l.default) })
    //}

    //const fcUrl = 'localhost:44348'
    //const fcUrl = 'beta.fleetconnect.com.au'
    //const fcUrl = 'fleetconnect.com.au'

    const getCompany = (cid) => {
        callApi('companies/GetCompanyCid', cid)
            .then(resp => {
                cookies.session_var.mcid = cid
                setCookie('session_var', cookies.session_var, {
                    httpOnly: false,
                    path: '/',
                    secure: true,
                    domain: 'fleetconnect.com.au',
                })
                dispatch(setCompany(resp))
            }).catch(error =>
                Notify({
                    message: error,
                    minHeight: 45,
                    minWidth: 150,
                    type: 'error',
                }, {
                    position: 'bottom center',
                    direction: 'up-push'
                })
            )
    }
    const getMainMenu = () => {
        setMenuLoading(true)
        callApi('Menu/GetSideMenu', {
            companyid: currentcompany.id,
            userid: currentuser.id,
            parentid: null,
            searchValue: null,
        })
            .then(res => {
                //console.log(res)
                setMenuLoading(false)
                setMainMenu(res)
            }).catch(err => {
                Notify({
                    message: err,
                    minHeight: 45,
                    minWidth: 150,
                    type: 'error',
                }, {
                    position: 'bottom center',
                    direction: 'up-push'
                })
            })
    }
    const itemClick = (link, itemId, itemType, itemCid, state) => {
        if (!!itemCid && itemCid !== currentcompany.id) {
            getCompany(itemCid)
        }
        if (link.startsWith('https://')) {
            window.location = link
        } else if (state) {
            if (location.pathname === link) {
                link = null
            }
            navigate(link, { state: state })
        } else if (itemType) {
            if (location.pathname === link) {
                link = null
            }
            navigate(link, { state: { id: itemId, type: itemType } })
        } else if (itemId) {
            if (location.pathname === link) {
                link = null
            }
            navigate(link, { state: itemId })
        } else {
            navigate(link)
        }
    }
    const menuItemRender = (item) => {
        if (item.type === 'sub') {
            if (item.loading === true) {
                return (
                    <Box width='100%' sx={{
                        display: 'flex',
                        alignItems: 'center',
                    }}>
                        <LoadIndicator style={{ margin: 'auto' }} width='24px' height='24px' />
                    </Box>
                )
            } else {
                return (
                    <Box width='100%' sx={{
                        display: 'flex',
                    }}>
                        <Typography sx={{ fontSize: 12, flex: 1, color: item.expanded ? theme.palette.success.main : theme.palette.text.primary }} >
                            {item.text}
                        </Typography>
                        {item.triplink &&
                            <Box sx={{
                                pl: 2,
                                color: '#979898',
                                '&:hover': {
                                    color: theme.palette.secondary.main,
                                }
                            }}
                                onClick={(e) => itemClick(item.triplink, item.itemid, item.itemType, item.itemcid)}>
                                <i style={{ fontSize: '16px' }} className='fa-duotone fa-route' />
                            </Box>
                        }
                        {item.maplink &&
                            <Box sx={{
                                pl: 2,
                                color: '#979898',
                                '&:hover': {
                                    color: theme.palette.secondary.main,
                                }
                            }}
                                onClick={(e) => itemClick(item.maplink, item.itemid, item.itemType, item.itemcid)}>
                                <i style={{ fontSize: '16px' }} className='fa-duotone fa-location-dot' />
                            </Box>
                        }
                        {item.editlink &&
                            <Box sx={{
                                pl: 2,
                                color: '#979898',
                                '&:hover': {
                                    color: theme.palette.secondary.main,
                                }
                            }}
                                onClick={(e) => itemClick(item.editlink, item.itemid)}>
                                <i style={{ fontSize: '16px' }} className='fa-duotone fa-wrench' />
                            </Box>
                        }
                    </Box>
                )
            }
        } else if (item.type === 'link' && item.icon) {
            return (
                <Box width='100%' sx={{
                    display: 'flex',
                    fontSize: '20px',
                    '&:hover': {
                        color: theme.palette.secondary.main
                    }
                }}>
                    <i style={{
                        minWidth: '40px',
                        marginLeft: '14px',
                    }} className={item.icon} ></i>
                    <Typography sx={{ fontSize: '16px', fontWeight: 600, color: item.selected ? theme.palette.text.secondary : 'inherit', marginRight: 'auto' }} >
                        {item.text}
                    </Typography>
                </Box>
            )
        } else if (item.type === 'link') {
            return (
                <Box width='100%' sx={{
                    display: 'flex',
                    fontSize: '20px',
                    '&:hover': {
                        color: theme.palette.secondary.main
                    }
                }}>
                    <Typography sx={{ fontSize: '16px', fontWeight: 600, color: item.selected ? theme.palette.text.secondary : 'inherit', marginRight: 'auto' }} >
                        {item.text}
                    </Typography>
                </Box>
            )
        } else if (item.type === 'head') {
            return (
                <Typography variant='menuSubTitle' sx={{
                    mt: 3,
                    color: theme.sidebar.header.color
                }}>{item.text}</Typography>
            )
        }
    }
    const menuItemClick = (e) => {
        if (e.itemData.link !== null) {
            props.setDrawerState(false)
            itemClick(e.itemData.link, e.itemData.itemid, e.itemData.itemType, e.itemData.itemcid, e.itemData.state)
        } else {
            e.event.preventDefault()
        }
    }
    const logoClick = (e) => {
        console.log(`logoClick(${JSON.stringify(cookies.session_var)})`)
        if (cookies.session_var.lcid !== currentcompany.id || cookies.session_var.luid !== currentuser.id) {
            callApi('Users/GetAuthDetails', {
                luid: cookies.session_var.luid,
                muid: cookies.session_var.luid,
                lcid: cookies.session_var.lcid,
                mcid: cookies.session_var.lcid,
            })
                .then(resp => {
                    if (resp.cookie) {
                        setCookie('session_var', JSON.stringify(resp.cookie), {
                            httpOnly: false,
                            path: '/',
                            secure: true,
                            domain: 'fleetconnect.com.au',
                        })
                    }
                    console.log(`session_var(${JSON.stringify(resp.cookie)})`)
                    dispatch(setUser(resp.user))
                    dispatch(setCompany(resp.comp))
                }).catch(error =>
                    Notify({
                        message: error,
                        minHeight: 45,
                        minWidth: 150,
                        type: 'error',
                    }, {
                        position: 'bottom center',
                        direction: 'up-push'
                    })
                )
        }
        //if (cookies.session_var.lcid !== currentcompany.id) {
        //    callApi('companies/GetCompanyCid', cookies.session_var.lcid)
        //        .then(resp => {
        //            cookies.session_var.mcid = cookies.session_var.lcid
        //            setCookie('session_var', cookies.session_var, {
        //                httpOnly: false,
        //                path: '/',
        //                secure: true,
        //                domain: 'fleetconnect.com.au',
        //            })
        //            console.log(`logoClick.setCookie(${JSON.stringify(cookies.session_var)})`)
        //            dispatch(setCompany(resp))
        //        }).catch(error =>
        //            Notify({
        //                message: error,
        //                minHeight: 45,
        //                minWidth: 150,
        //                type: 'error',
        //            }, {
        //                position: 'bottom center',
        //                direction: 'up-push'
        //            })
        //        )
        //    //navigate(0)
        //}
        //if (cookies.session_var.luid !== currentuser.id) {
        //    callApi('Users/GetCurrentUser', cookies.session_var.luid)
        //        .then(resp => {
        //            cookies.session_var.muid = cookies.session_var.luid
        //            setCookie('session_var', cookies.session_var, {
        //                httpOnly: false,
        //                path: '/',
        //                secure: true,
        //                domain: 'fleetconnect.com.au',
        //            })
        //            dispatch(setUser(resp))
        //        }).catch(error =>
        //            Notify({
        //                message: error,
        //                minHeight: 45,
        //                minWidth: 150,
        //                type: 'error',
        //            }, {
        //                position: 'bottom center',
        //                direction: 'up-push'
        //            })
        //        )
        //}
    }
    const itemExpanded = (e) => {
        if (e.event) {
            //console.log('Expanded', e)
            e.itemData.loading = true
            e.component.repaint()
            callApi('Menu/GetSideSubMenu', {
                companyid: currentcompany.id,
                userid: currentuser.id,
                parentid: e.node.key,
                searchValue: srchTerm,
            })
                .then(res => {
                    //console.log(res)
                    e.itemData.loading = false
                    const a1 = mainMenu.filter(f => f.parentId !== e.node.key)
                    setMainMenu(a1.concat(res))
                }).catch(err => {
                    e.itemData.loading = false
                    Notify({
                        message: err,
                        minHeight: 45,
                        minWidth: 150,
                        type: 'error',
                    }, {
                        position: 'bottom center',
                        direction: 'up-push'
                    })
                })
        }
    }
    const itemCollapsed = (e) => {
        if (e.event) {
            console.log('Collapsed', e)
        }
    }
    const menuReady = (e) => {
        if (e.component.getSelectedNodeKeys().length === 0) {
            const itm = mainMenu.find(f => location.pathname.includes(f.link))
            if (itm) {
                e.component.selectItem(itm.id)
            }
        }
    }
    return (
        <Box sx={{ width: 258, backgroundColor: theme.palette.common.black, height: '100vh', display: 'flex', flexDirection: 'column' }}>
            <Box sx={{
                flexGrow: 0,
                backgroundColor: theme.sidebar.header.background,
                p: 6,
                justifyContent: 'center',
                cursor: 'pointer'
            }}
                onClick={logoClick}>
                <img src={logoFile} alt='Logo' />
            </Box>
            {smallScreen &&
                <Box>
                    <Button style={{float: 'right'}}
                    type='normal'
                    stylingMode='text'
                icon='fa-duotone fa-chevron-left'
                    onClick={() => props.setDrawerState(false)}
                    />
                </Box>
            }
            <Box ref={pageRef} sx={{ height: '100%' }}>
                <ErrorBoundary>
                    {!menuLoading &&
                        <TreeView ref={menuRef}
                            id='menu-treeview'
                            height={menuHeight}
                            dataSource={mainMenu}
                            dataStructure='plain'
                            rootValue="''"
                            keyExpr='id'
                            displayExpr='text'
                            parentIdExpr='parentId'
                            hasItemsExpr='hasItems'
                            expandNodesRecursive={false}
                            itemRender={menuItemRender}
                            selectByClick={true}
                            selectionMode='single'
                        selectNodesRecursive={false}
                        onContentReady={menuReady}
                        onItemClick={menuItemClick}
                        onItemExpanded={itemExpanded}
                        onItemCollapsed={itemCollapsed}
                        />
                    }
                </ErrorBoundary>
            </Box>
            <Backdrop
                sx={{ zIndex: (theme) => theme.zIndex.drawer, position: "absolute" }}
                open={menuLoading}
            >
                <CircularProgress color="secondary" />
            </Backdrop>
        </Box>
    )
};

export default SideBar
